module.exports = __webpack_public_path__ + "static/media/RP-28.690c6b6e.pdf";